/* Frontend-only, single-tab fetch guard; not server/checkout enforcement. */
(function (window) {
  'use strict';
  if (window.RTMKeyringLimit) return;
  const variantId = '66366735122781';
  const max = 2;
  const message = 'Du kannst maximal 2 NFC-Schlüsselanhänger pro Bestellung kaufen.';
  const nativeFetch = window.fetch.bind(window);
  let queue = Promise.resolve();
  const target = item => String(item.variant_id ?? item.id) === variantId;
  const quantity = value => Math.max(0, Number(value) || 0);
  const total = cart => cart.items.reduce((sum, item) => sum + (target(item) ? quantity(item.quantity) : 0), 0);
  const added = payload => (Array.isArray(payload.items) ? payload.items : [payload])
    .reduce((sum, item) => sum + (String(item.id) === variantId ? quantity(item.quantity ?? 1) : 0), 0);
  const findLine = (items, id) => {
    const key = items.findIndex(item => item.key === String(id));
    return key >= 0 ? key : items.findIndex(item => String(item.variant_id ?? item.id) === String(id));
  };
  function projected(cart, action, payload) {
    if (action === 'add') return total(cart) + added(payload);
    const items = cart.items.map(item => ({ ...item }));
    if (action === 'change') {
      const index = payload.line != null ? Number(payload.line) - 1 : findLine(items, payload.id);
      if (items[index] && payload.quantity != null) items[index].quantity = quantity(payload.quantity);
    } else if (action === 'update' && payload.updates) {
      if (Array.isArray(payload.updates)) {
        payload.updates.forEach((value, index) => { if (items[index] && value != null) items[index].quantity = quantity(value); });
      } else {
        Object.entries(payload.updates).forEach(([id, value]) => {
          const index = findLine(items, id);
          if (index >= 0) items[index].quantity = quantity(value);
          else if (id === variantId) items.push({ variant_id: variantId, quantity: quantity(value) });
        });
      }
    }
    return total({ items });
  }
  // Decode Shopify's common form fields, ignoring properties/selling-plan fields.
  function formPayload(body) {
    const result = {};
    for (const [name, value] of body.entries()) {
      if (['id', 'quantity', 'line'].includes(name)) result[name] = value;
      let match = /^items\[(\d+)\]\[(id|quantity)\]$/.exec(name);
      if (match) {
        result.items = result.items || [];
        result.items[Number(match[1])] = result.items[Number(match[1])] || {};
        result.items[Number(match[1])][match[2]] = value;
      }
      match = /^updates\[([^\]]*)\]$/.exec(name);
      if (match) {
        result.updates = result.updates || (match[1] === '' ? [] : {});
        if (match[1] === '') result.updates.push(value);
        else result.updates[match[1]] = value;
      }
    }
    return result;
  }
  async function parseBody(input, init) {
    let body = init && init.body;
    if (body == null && input instanceof Request) {
      const copy = input.clone();
      const type = copy.headers.get('content-type') || '';
      if (/multipart\/form-data/i.test(type)) body = await copy.formData();
      else if (/json|x-www-form-urlencoded|text\/plain/i.test(type)) body = await copy.text();
      else return null;
    }
    if (body instanceof FormData || body instanceof URLSearchParams) return formPayload(body);
    if (typeof body !== 'string') return null;
    try {
      const payload = JSON.parse(body);
      return payload && typeof payload === 'object' ? payload : null;
    } catch (_) {
      return body.includes('=') ? formPayload(new URLSearchParams(body)) : null;
    }
  }
  function errorResponse(status, text) {
    return new Response(JSON.stringify({ status, message: text, description: text, errors: text }), {
      status, headers: { 'Content-Type': 'application/json; charset=utf-8' }
    });
  }
  async function validate(input, init, action, url) {
    let payload;
    try { payload = await parseBody(input, init); } catch (_) { return nativeFetch(input, init); }
    if (!payload || (action === 'add' && !added(payload)) ||
        (action === 'update' && !payload.updates)) return nativeFetch(input, init);
    let cart;
    try {
      const root = window.Shopify && window.Shopify.routes && window.Shopify.routes.root;
      const cartURL = new URL(root ? root.replace(/\/?$/, '/') + 'cart.js' : url.pathname.replace(/cart\/[^/]+$/, 'cart.js'), window.location.href);
      // Never trust route metadata to send cart reads to a different origin.
      if (cartURL.origin !== window.location.origin) throw new Error('Invalid cart origin');
      const response = await nativeFetch(cartURL.href, { method: 'GET', cache: 'no-store', credentials: 'same-origin' });
      if (!response.ok) throw new Error('Cart unavailable');
      cart = await response.json();
      if (!Array.isArray(cart.items)) throw new Error('Invalid cart');
    } catch (_) {
      return errorResponse(503, 'Der Warenkorb konnte nicht geprüft werden. Bitte versuche es erneut.');
    }
    const before = total(cart);
    const after = projected(cart, action, payload);
    // Existing excess may remain unchanged or decrease; never permit an increase.
    if (after > max && after > before) return errorResponse(422, message);
    return nativeFetch(input, init);
  }
  function guardedFetch(input, init) {
    let url;
    try { url = new URL(input instanceof Request ? input.url : String(input), window.location.href); }
    catch (_) { return nativeFetch(input, init); }
    const method = String((init && init.method) || (input instanceof Request ? input.method : 'GET')).toUpperCase();
    const match = /\/cart\/(add|change|update)(?:\.js)?$/.exec(url.pathname);
    if (url.origin !== window.location.origin || method !== 'POST' || !match) return nativeFetch(input, init);
    // Queue through the completed mutation, not merely through its cart read.
    const result = queue.then(() => validate(input, init, match[1], url));
    queue = result.catch(() => {});
    return result;
  }
  window.RTMKeyringLimit = Object.freeze({ variantId, max, message, total, projected, guardedFetch });
  window.fetch = guardedFetch;
})(window);
